import React from 'react';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import CallControls from '../callControls';
// import { track } from 's2s-app-service';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';

import useCallInfo from "../../hooks/callInfo";

const composedHoc = compose(injectIntl);
const ComposedCallControls = composedHoc(CallControls);

const UserActions = styled.div`
  width : 100%;
`;

const DTMFHeader = styled.div`
  align-items: center;
  background-color: ${colorGrid.brand6};
  color: ${colorGrid.gray0};
  display: flex;
  height: 40px;
  margin: 0px auto;
  padding-left: 15px;
`;

const AttendedTransferUserControls = (props) => {

  const [callInfo] = useCallInfo();

  let returnJSX;

  if (props.showDTMFKeypad) {
    //console.log('showDTMFKeypad --- 3');
    returnJSX = (
      <UserActions className="AttendedTransfer UserActions" >
        <DTMFHeader {...props} />
      </UserActions>
    );
  } else {
    //console.log('**************************************** 2', callInfo.activeCallId);
    returnJSX = (
      <UserActions className="AttendedTransfer UserActions">
        <ComposedCallControls
          className="CallControls"
          cbButtonClick={props.cbHandleCallControlActionClick}
          isAttendedTransfer
          isMuted={callInfo.inprogressCalls[callInfo.activeCallId] ? callInfo.inprogressCalls[callInfo.activeCallId].muted : false}
          isOnHold={callInfo.inprogressCalls[callInfo.activeCallId] ? callInfo.inprogressCalls[callInfo.activeCallId].held : false}
        />
      </UserActions>
    );
  }
  return returnJSX;
};


AttendedTransferUserControls.propTypes = {
  cbHandleCallControlActionClick: PropTypes.func,
  intl: PropTypes.object,
};

AttendedTransferUserControls.defaultProps = {

};

export default injectIntl(AttendedTransferUserControls);
